import React from 'react';
import _ from 'lodash';
import { renderToString } from 'react-dom/server';
import StackedAreaChart from 'components/StackedAreaChart';
import {
  getColor,
  NEW_WORK_COLOR,
  REFACTOR_COLOR,
  REWORK_COLOR
} from 'common/constants/_colors';
import WorkBreakdownTooltip from 'components/Tooltips/WorkBreakdownTooltip';
import {
  calcWorkBreakDownData,
  getWorkBreakdownConfigurations
} from '../../util';
import { numeralify } from 'common/utils/utils';
import TooltipTitle from 'components/Tooltips/TooltipTitle';

const WorkBreakdownTrendWidget = ({ data = {} }) => {
  const dataX = data.x || {};
  const xCategories = Object.keys(dataX);
  const yData = _.isEmpty(data.y) ? [] : data.y;

  return (
    <StackedAreaChart
      chartOptionsProp={{
        xAxis: {
          categories: xCategories,
          labels: {
            formatter() {
              const iteration = dataX[this.value];
              return _.get(iteration, 'name', '');
            }
          },
          reversed: true,
          crosshair: {
            width: 1,
            dashStyle: 'Solid'
          }
        },
        yAxis: {
          title: {
            text: ''
          },
          min: 0,
          tickAmount: 6,
          labels: {
            formatter() {
              return this.value / 1000 + 'k';
            }
          }
        },
        tooltip: {
          shared: true,
          formatter() {
            const iterationId = this.x;
            const dataX = data.x[iterationId];
            const iterationName = _.get(dataX, 'name', '');

            return renderToString(
              <WorkBreakdownTooltip
                title={
                  <TooltipTitle boldText={iterationName} text={dataX.dates} />
                }
                configurations={getWorkBreakdownConfigurations(
                  calcWorkBreakDownData(yData[dataX.index])
                )}
                headLine={{
                  value: numeralify(yData[dataX.index]?.changes),
                  description: 'CODE CHANGES'
                }}
              />
            );
          }
        },
        series: [
          {
            name: 'NEW WORK',
            data: yData.flatMap(({ newWork }) => newWork),
            color: getColor(NEW_WORK_COLOR),
            lineWidth: 0
          },
          {
            name: 'REFACTOR',
            data: yData.flatMap(({ refactor }) => refactor),
            color: getColor(REFACTOR_COLOR),
            lineWidth: 0
          },
          {
            name: 'REWORK',
            data: yData.flatMap(({ rework }) => rework),
            color: getColor(REWORK_COLOR),
            lineWidth: 0
          }
        ]
      }}
    />
  );
};

export default WorkBreakdownTrendWidget;
